import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/shared/snackbar/snackbar.component';
import * as moment from 'moment';
import { UserInfoService } from './user-info.service';

export interface BreadCrumbs {
  parent: string;
  children: Children[]
}

export interface Children {
  child :string,
  link: string,
}

@Injectable({
  providedIn: 'root'
})

export class CommonService {
  baseUrl =  environment.baseUrl;
  applicationVersion: number;
  userInfo: any;
  environment: string;
  pId: string;
  userInfoSource = new BehaviorSubject<any>('');
  currentUserInfo = this.userInfoSource.asObservable();

  userNotificationSource = new BehaviorSubject<any>('');
  currentUserNotificaton = this.userNotificationSource.asObservable();

  private caseIDInfoSource = new BehaviorSubject<any>('');

  private breadcrumbSource = new BehaviorSubject<any>('');
  breadcrumb = this.breadcrumbSource.asObservable();

  private showPrintosHeaderSource = new BehaviorSubject<any>(false);
  showPrintosHeader = this.showPrintosHeaderSource.asObservable();
  orgID: any;
  orgName: any;
  custID: any;
  custEmail: any;
  name: any;
  myKnowledgeUrl = ''

  organization: any = {
    crm_enable: false,
    is_support_account: false
  }
  isAMSReseller: boolean = false
  isAMSRegion: boolean = false

  constructor(private http: HttpClient,
              private userInfoService: UserInfoService,
              private snackbar: MatSnackBar) {}

  setPrintosHeader(value: boolean) {
    this.showPrintosHeaderSource.next(value);
  }

  get isPrintosHeader() {
    return this.showPrintosHeaderSource.getValue();
  }

  get userInfoData() {
   return this.userInfoSource.getValue();
  }

  setCaseID(value) {
    this.caseIDInfoSource.next(value);
  }

  get CaseID() {
    return this.caseIDInfoSource.getValue();
  }

  get fullName() {
    return this.name
  }

  get organizationName() {
    return this.orgName
  }

  get knowledgeUrl() {
    return this.myKnowledgeUrl;
  }

  getUserInfo(userConfiguration, response) {
      let res = response.result;
      res.user = userConfiguration.result.user;
      res.organization = userConfiguration.result.organization;
      res.is_upselling = userConfiguration.result.is_upselling;
      res.case_management_enabled = userConfiguration.result.case_management_enabled;
      res.is_support_account_from_me = userConfiguration?.result?.is_support_account
      this.userInfo = res;
      this.myKnowledgeUrl = res.my_knowledge_url;
      this.userInfoSource.next(this.userInfo);
      this.userNotificationSource.next(response.result)
      this.applicationVersion = res.application_version;
      this.environment = res.environment
      this.orgID = res.organization.organization_id;
      this.orgName = res.organization.name;
      this.custID = res.user.user_id;
      this.custEmail = res.user.email;
      this.name = `${res.user.first_name} ${res.user.last_name}`;
      this.updateTheOrganization(this.userInfo)
      this.userInfoService.storeUserInfo(res)
      this.checkAMSRegion()
      this.hasAMSReseller()
  }

  hasAMSReseller() {
    if(this.userInfoData?.organization?.region == 'AMS' && !this.userInfoData.is_support_account_from_me) {
      this.isAMSReseller = true
    } else {
      this.isAMSReseller = false
    }
  }

  hasAMSSupported() {
    if(this.userInfoData?.organization?.region == 'AMS' && this.userInfoData.is_support_account_from_me) {
      return true
    } 
    return false
  }

  checkAMSRegion() {
    if(this.userInfoData?.organization?.region == 'AMS') {
      this.isAMSRegion = true
    } else {
      this.isAMSRegion = false
    }
  }

  get isSupportAccount() {
    return this.userInfoData?.is_support_account_from_me;
  }

  storeEmail(res) {
    this.custEmail = res?.result?.user?.email;
  }

  updateTheOrganization(info) {
    this.organization = {
      crm_enabled: info.crm_enabled,
      is_support_account_from_me: info.is_support_account_from_me,
      is_support_account: info.is_support_account_from_me
    }
  }

  getOrganization() {
    return this.organization;
  }

  updateInstalledBaseShoutout() {
   return this.http.get<any>(this.baseUrl + '/services/sc/api/v1/update_installed_base_shoutout');
  }

  get organizationID() {
    return this.orgID;
  }

  get customerID() {
    return this.custID;
  }

  get customerEmail() {
    return this.custEmail;
  }

  commonTimeZone() {
    return this.http.get<any>(this.baseUrl + '/services/core/api/external/v1/timezones');
  }

  commonCountries() {
    return this.http.get<any>(this.baseUrl + '/services/core/api/external/v1/countries')
  }

  // formatUnits(page) {
  //   let sqm = this.translate.instant('SQM')
  //   let sq_inches = this.translate.instant('SQ_INCHES')
  //   let gallons = this.translate.instant('GALLONS')
  //   let liters = this.translate.instant('LITERS')

  //   let unit = this.userInfoData ? this.userInfoData?.user?.unit_system : null;
  //   if(unit == null) {
  //     return { printUnit: '', inkUnit: ''}
  //   }
  //   unit = unit.toLowerCase();
  //   if(page == 'usage') {
  //     if(unit == "imperial") {
  //       return { printUnit: sq_inches, inkUnit: gallons}
  //     } else {
  //      return { printUnit: sqm, inkUnit: liters}
  //     }
  //   } else {
  //     if(unit == "imperial") {
  //       return { printUnit: 'SQIN', inkUnit: 'GAL'}
  //     } else {
  //      return { printUnit: 'SQM', inkUnit: 'L'}
  //     }
  //   }

  // }

  downLoadReport(url) {
    return this.http.get<Blob>(url, {observe: 'response', responseType: 'blob' as 'json'});
  }

  store400Error() {
    localStorage.setItem('printerLimit', 'true');
  }

  clear400Error() {
    localStorage.removeItem("printerLimit");
  }

  
  failedModal(message) {
    this.alertModal({
      heading: message,
      subHeading: '',
      isSuccess: false
    });
  }

  successModal(message, subHeading) {
    this.alertModal({
      heading: message,
      subHeading,
      isSuccess: true
    });
  }

  alertModal(data) {
    const snackRef = this.snackbar.openFromComponent(SnackbarComponent, {
      data: {
        ...data,
        showCloseButton: true,
        close: () => snackRef.dismiss()
      },
      duration: 10000,
      panelClass: 'pending-snackbar',
    });
  }

  solutionError(action, err) {
    if(err.status > 500) {
      action.has500Err = true
    } else if(err.status == 400) {
      action.has400Err = true
    }
  }

  orderParts(paramsObject) {
    let params = new HttpParams();
    for (let key in paramsObject) {
        params = params.set(key, paramsObject[key]);
    }
    return this.http.get<any>(this.baseUrl + `/services/case/api/v1/parts_order_button_url`, {params})
  }


  formatDate(value) {
    if(!value) return '-';
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(value).format('MM/DD/YY');
    }
    return moment(value).format('DD/MM/YY');
  }

  formatDateWithTime(value) {
    if(!value) return '-';
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(value).format('MM/DD/YY, h:mm A');
    }
    return moment(value).format('DD/MM/YY, h:mm A');
  }

  getDateTimeFormat(value) {
    if(!value) return '-';
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(new Date(value)).format('MM/DD/YY, hh:mm');
    }
    return moment(new Date(value)).format('DD/MM/YY, hh:mm');
  
  }

  formatGenerateTs(value) {
    if(!value) return '-';
    let time = new Date(value)
    let localTime = new Date(time.getTime() - time.getTimezoneOffset() * 60000);
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(localTime).format('MM/DD/YY, hh:mm');
    }
    return moment(localTime).format('DD/MM/YY, hh:mm');
  }

  formatCloseTs(value) {
    if(!value) return '-';
    let date = new Date(value)
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(date).format('MM/DD/YY, hh:mm');
    }
    return moment(date).format('DD/MM/YY, hh:mm');
  }

  getTheDateFormatForPicker() {
    if(this.userInfo?.organization?.region == 'AMS') {
      return 'MM/DD/YY';
    }
    return 'DD/MM/YY'
  }

  getTitleAndBody(newTitle, newBody) {
    let title = ''
    if(newTitle == 'access required') {
      title = 'ACCESS_REQUIRED'
      newBody = 'YOUR_PARTNER_ID_DOESNT'
   }
   if(newTitle == 'country not available') {
     title = 'COUNTRY_NOT_AVAIBLE'
     newBody = "THIS_SERVICE_ISNT_AVAILABLE"
   }
   if(newTitle == 'warning') {
     title = 'LEAVING_PRINTOS'
     newBody = "FOR_ACCESS_ISSUES"
   }

   return {title, newBody}
  }

  formatDateLog(value) {
    if(!value) return '-';
    if(this.userInfo?.organization?.region == 'AMS') {
      return moment(value, 'DD MMM YYYY ,HH[h]').format('MM/DD/YY');
    }
    return moment(value, 'DD MMM YYYY ,HH[h]').format('DD/MM/YY');
  }

  hasRegion() {
    if(!this.userInfo?.organization?.region || this.userInfo?.organization?.region ==  null || this.userInfo?.organization?.region ==undefined) {
      return false
    }
    return true
  }
  
  // 2952 changes
  applyAdditionalDiscountForContractRequest(year: number, index: number, printerData: any){
    switch (year) {
      case 2:
        printerData[index].additional_discount = 5;
        break;
      case 3:
        printerData[index].additional_discount = 10;
        break;
      case 4:
        printerData[index].additional_discount = 15;
        break;
      case 5:
        printerData[index].additional_discount = 20;
        break;
      default:
        printerData[index].additional_discount = 0;
    }
  }

  checkEndDateAutoRenewal(plan_end_date) {
    if (moment(plan_end_date).format("DD/MM/YYYY") == '01/01/2099') {
      return true;
    }
    return false;
  }

  /**
   * "start: 12/20/2023, end: 12/19/2024 ", 1
   * "start: 12/20/2023, end: 12/18/2024 ", 0
   * "start: 12/20/2023, end: 12/20/2025 ", 2
   * @param start date
   * @param end date
   * @returns difference in Years
   */
  calculateDiffInYears(start: any, end: any) {
    if(Array.isArray(end) && end?.length > 0 && end[0].value !== "autorenewal" && moment(end[0].value).format("DD/MM/YYYY") != '01/01/2099'){
      end = end[0].value;
    }
    let s = new Date(start);
    s.setHours(0, 0, 0, 0);
    let e = new Date(end);
    e.setHours(23, 59, 59, 1000);
    let start_date = moment(s);
    let end_date = moment(e);
    let diffYears = (moment(end_date).diff(moment(start_date), 'years', true));
    return Math.floor(diffYears);
  }

  calculateBeforeAndAfterDiscount(printerData: any) {
    let priceBeforeDiscount: number = 0;
    let priceAfterDiscount: number = 0;
    printerData.forEach(printer => {
      priceBeforeDiscount += printer['priceBeforeDiscount'] ?? 0;
      priceAfterDiscount += printer['priceAfterDiscount'] ?? 0;
    });
    priceBeforeDiscount = Number(priceBeforeDiscount.toFixed(2));
    priceAfterDiscount = Number(priceAfterDiscount.toFixed(2));
    return {priceBeforeDiscount, priceAfterDiscount};
  }

  isEndDateAutorenewal(end_date: any){
    let result = false;
    if(typeof end_date === 'string'){
      if (end_date === "autorenewal" || moment(end_date).format("DD/MM/YYYY") == '01/01/2099' || end_date === '') {
        result = true;
      }else{
        result = false;
      }
    } else if (moment.isMoment(end_date)) {
      if (moment(end_date).format("DD/MM/YYYY") == '01/01/2099') {
        result = true;
      } else {
        result = false;
      }
    } else if (Array.isArray(end_date) && end_date?.length > 0) {
      if (end_date[0].value === "autorenewal") {
        result = true;
      } else {
        result = false;
      }
    } else{
      result = false;
    }

    return result;
  }

  trapFocusAtTheEnd(focusContainer, id, last_element_id): void {
    const container = focusContainer.nativeElement as HTMLElement;
    container.addEventListener('keydown', (event: any) => {
      let doc = document.getElementById(id)

      if (document.activeElement.id === last_element_id) {
        doc && event.preventDefault()
        doc?.setAttribute('tabindex', '0')
        doc?.focus()
      } else {
        doc?.setAttribute('tabindex', '-1')
      }
 
    });
  }
  setTabIndexForBreadcrumb() {
  setTimeout(()=>{
    var breadcrumbs = document.getElementsByClassName('pros-breadcrumbs-container')[0]
    breadcrumbs?.setAttribute('aria-label','Breadcrumb')
    var breadcrumblist = document.getElementsByClassName('pros-breadcrumb-display');
    var totalBreadcrumbs = breadcrumblist?.length;
    console.log('breadcrumb',totalBreadcrumbs)
    for(var i =0;i < totalBreadcrumbs ;i++) {
      if(i === totalBreadcrumbs - 1) {
        breadcrumblist[i].setAttribute('aria-current','page');
        breadcrumblist[i].removeAttribute('tabindex')
      } else {
      breadcrumblist[i].setAttribute('tabindex','0')
      }
    }
  }, 150)
  }
}
